export enum ESidenavMenuType {
    MOBILE_FEEDS = 1,
    LAYOUT,
}